import Typography from '@mui/material/Typography';
import { CollapsibleTable } from "../../components/CollapsibleTable";
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { ITicketsData } from "./TicketsData";
import { tableHeaderStyles } from "./styled";
const cols = ['Rating', 'Description', 'Ticket Number', 'Issue Date', 'Expiry Date', 'Grade'];

export const Tickets = ({ data }: { data: ITicketsData }) => (
  <MainContainer hasGreyBg>
    <Typography sx={tableHeaderStyles} data-automation="tbl-title">Tickets</Typography>
    <Typography 
      component={'div'} 
      variant='container' 
      data-automation="data-container"
    >
      <ScrollIndicatorsComp>
        <CollapsibleTable
          cols={cols.map(cal => ({ title: cal }))}
          rows={data.tickets?.map((ticket) => ({
            rating: `${ticket.ratingCode} - ${ticket.ratingDescription}`,
            description: ticket.ticketDescription,
            number: ticket.ticketNumber,
            issueDate: ticket.ticketIssueDate,
            expiryDate: ticket.ticketExpiryDate,
            grade: ticket.ticketGrade,
          })) || []}
          isOneLevel={true}
          dataAutomation={{
            header: "tbl-header",
            columns: ["rating", "description", "ticket-no", "iss-date", "exp-date", "grade"],
            tBody: "tbl-body",
            rows: "tbl-row",
          }}
        />
      </ScrollIndicatorsComp>
    </Typography>
  </MainContainer>
)